import { jsx as _jsx } from "react/jsx-runtime";
import { Box, CircularProgress } from '@mui/material';
export const LoadingView = (props) => {
    return (_jsx(Box, { ...props, display: "flex", alignItems: "center", justifyContent: "center", children: _jsx(CircularProgress, {}) }));
};
